import React from "react";
import { Layout, Card, Text, Badge, BlockStack, SkeletonBodyText } from "@shopify/polaris";

const SummaryCards = ({ data, isLoading }) => {
  if (isLoading || !data) {
    return (
      <Layout>
        {[1, 2, 3, 4].map((i) => (
          <Layout.Section key={i} variant="oneThird">
            <Card>
              <div style={{ padding: "16px" }}>
                <SkeletonBodyText lines={3} />
              </div>
            </Card>
          </Layout.Section>
        ))}
      </Layout>
    );
  }

  const formatCurrency = (value) => {
    return `${value.toFixed(2)} KWD`;
  };

  const formatNumber = (value) => {
    return value.toLocaleString();
  };

  const formatPercentage = (value) => {
    const isPositive = value >= 0;
    const color = isPositive ? "success" : "critical";
    const symbol = isPositive ? "+" : "";

    return (
      <Badge tone={color}>
        {symbol}
        {value.toFixed(2)}%
      </Badge>
    );
  };

  const cards = [
    {
      title: "Total Revenue",
      value: formatCurrency(data.totalRevenue),
      subtitle: `Growth: ${formatPercentage(data.growthPercentage)}`,
      icon: "💰",
    },
    {
      title: "Today's Revenue",
      value: formatCurrency(data.todayRevenue),
      subtitle: `${formatNumber(data.totalOrders)} total orders`,
      icon: "📊",
    },
    {
      title: "Average Order Value",
      value: formatCurrency(data.averageOrderValue),
      subtitle: "Per transaction",
      icon: "💳",
    },
    {
      title: "Customers",
      value: formatNumber(data.totalCustomers),
      subtitle: `${data.repeatRate.toFixed(1)}% repeat rate`,
      icon: "👥",
    },
  ];

  return (
    <Layout>
      {cards.map((card, index) => (
        <Layout.Section key={index} variant="oneThird">
          <Card>
            <div style={{ padding: "16px" }}>
              <BlockStack gap="200">
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                  }}
                >
                  <Text variant="headingSm" as="h3" fontWeight="medium">
                    {card.title}
                  </Text>
                  <span style={{ fontSize: "24px" }}>{card.icon}</span>
                </div>

                <Text variant="heading2xl" as="p" fontWeight="bold">
                  {card.value}
                </Text>

                <div>
                  {typeof card.subtitle === "string" ? (
                    <Text variant="bodySm" as="p" tone="subdued">
                      {card.subtitle}
                    </Text>
                  ) : (
                    <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                      <Text variant="bodySm" as="span" tone="subdued">
                        Growth:
                      </Text>
                      {card.subtitle}
                    </div>
                  )}
                </div>
              </BlockStack>
            </div>
          </Card>
        </Layout.Section>
      ))}
    </Layout>
  );
};

export default SummaryCards;
